<ng-container *transloco="let t">
  <!-- Shipping Options -->
  @let shippingOption = selectedShippingOption();

  <pxw-input-radio-group
    class="shipping-options"
    name="shippingOption"
    [label]="t('endOrder.shippingOptionLabel')"
    [options]="shippingOptionTypes()"
    [(ngModel)]="shippingOptionType"
    required
    [displayErrors]="isFormSubmitted()"
    [messages]="{
      required: t('endOrder.shippingOptionRequired'),
    }"
    layout="inline"
  >
    <ng-template #radioItemTemplate let-shippingOptionType>
      {{ t('endOrder.shippingOption_' + shippingOptionType) }}
    </ng-template>
  </pxw-input-radio-group>

  @if (shippingOption) {
    @if (shippingOption.type === typesOfShippings.IN_PLACE) {
      <pxw-input-text
        name="tableNumber"
        [label]="t('endOrder.tableNumberLabel')"
        [placeholder]="t('endOrder.tableNumberPlaceholder')"
        [(ngModel)]="tableNumber"
        [displayErrors]="isFormSubmitted()"
        required
        [messages]="{ required: t('endOrder.tableNumberRequired') }"
      />
    }

    @if (
      shippingOption.type === typesOfShippings.DELIVERY ||
      shippingOption.type === typesOfShippings.PARCEL
    ) {
      <pxw-address
        [workerServicesUrl]="workerServicesUrl()"
        [isFormSubmitted]="isFormSubmitted()"
        [(address)]="address"
        [disableAddressInMap]="shippingOption['disableAddressInMap'] || false"
        [countryCodes]="countryCodes()"
        [shippingCostResponse]="shippingCostResponse()"
        [calculatingShippingCost]="calculatingShippingCost()"
        [selectedParcelOption]="selectedParcelOption()"
        [checkoutData]="checkoutData()"
        (selectedParcelOptionChange)="onParcelOptionSelected($event)"
      />
    }
  }
</ng-container>
